import { ProductsFeatureRoutesConfig } from './ProductsFeatureRoutesConfig';

export interface ProductsFeatureConfig {
  routes?: ProductsFeatureRoutesConfig;
}

export const defaultProductPromotionsFeatureConfig: ProductsFeatureConfig = {};
